<template>
  <alert-dialog
    centered
    :title="$t('components.workout.signUpPrompt.dialogSaveWorkoutTitle')"
    :actions="[
      {
        title: $t('components.workout.signUpPrompt.dialogSaveWorkoutNo'),
        callback: handleDismiss
      },
      {
        title: $t('components.workout.signUpPrompt.dialogSaveWorkoutYes'),
        callback: handleSignUp
      }
    ]"
    :show="show"
    @close="handleDismiss"
  >
    {{ $t("components.workout.signUpPrompt.dialogSaveWorkoutContent") }}
  </alert-dialog>
</template>

<script>
import { isEmpty } from "@/lib/utils"

import AlertDialog from "@/components/AlertDialog"

export default {
  props: {
    show: { type: Boolean, default: false }
  },

  model: {
    prop: "show",
    event: "change"
  },

  components: {
    AlertDialog
  },

  methods: {
    handleDismiss() {
      this.closePrompt()
      this.$emit("dismiss")
    },

    handleSignUp() {
      this.closePrompt()
      this.$emit("confirm")
      this.$router.push("#auth")
    },

    closePrompt() {
      this.$emit("change", false)
    }
  },

  watch: {
    "$route.hash": function(hash) {
      if (isEmpty(hash)) {
        this.innerShow = false
        this.closePrompt()
      }
    }
  }
}
</script>
